/* tslint:disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration for Api services
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = 'http://ec2.sbb-backend.x2iq.com';
}

export interface ApiConfigurationInterface {
  rootUrl?: string;
}
